module.exports = __webpack_public_path__ + "img/scene4.bc800851.svg";